
import { NoticeProps } from "@/scripts/datatypes"
import {UserPrivateProfile} from "../../common-datatypes";

import { Component,Watch ,Mixins} from "vue-property-decorator";
import Common from '@/mixins/common'
import { ValidationObserver } from 'vee-validate'
import { ValidationFlags } from "vee-validate/dist/types/types";
//import { ValidationResult } from 'vee-validate/dist/types/types'


@Component({
  components: {
  }
})

export default class ScheduleSettings extends Mixins(Common) {
  isLoading = false
  notice: NoticeProps = {}
  disabledUpdateSettings = true
  userPrivateProfile = {} as UserPrivateProfile

  mounted(){
    console.log('mounted')

    this.observer = this.$refs.scheduleSettingsValidationObserver as InstanceType<typeof ValidationObserver>
  }

   @Watch('observer.flags')
  changeObservserFlags(flags: ValidationFlags){
    console.log('changeFlags')
    
    this.disabledUpdateSettings = ! flags.changed
  }

  observer = {} as InstanceType<typeof ValidationObserver>
  

  get feedCalendarUrl (){
    return (this.$store.state.userPrivateProfile.feedCalendarUrl || '') as string
  }

  async created() {
    console.trace('created')

    this.userPrivateProfile = {
      ...this.$store.state.userPrivateProfile
    }
  }

  async copyToClipboard(){
    await window.navigator.clipboard.writeText(this.feedCalendarUrl)

    this.notice = {
      message: 'scheduleSettings.copied',
      duration: 3000,
      isShow: true,
      type: {'is-success': true}
    }
  }

  async updateFeedCalendarUrl(val: '' | 'reset'){
    try{
      this.notice = {
				isShow: false,
      }

      if(!(val === '' || val === 'reset')){
        return
      }
        
      this.$store.commit("setLoading",true);
      this.isLoading = true

      const updatePrivateProfile: UserPrivateProfile = {
				feedCalendarUrl: val,
				schoolId: "",
				userId: "",
				lang: ""
			}

      await this.$updateDoc(this.$getUserPrivateProfileDocRef(),updatePrivateProfile)

      this.notice = {
        message: this.$t('schduleSettings.updated') as string,
        isShow: true,
        type: {'is-success': true}
      }
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('profile.error') as string
      
			const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
      this.observer.reset()
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.disabledUpdateSettings = true
    }
  }

  async updateSettings(){
    try{
      this.notice = {
				isShow: false,
      }

      if(! await this.observer.validate()){
        return
      }
      
      const updatePrivateProfile = {
        ...this.userPrivateProfile,
      }
      let field: string

      for(field in this.userPrivateProfile){
        if(this.observer.fields[field] && (this.observer.fields[field].dirty === true || this.observer.fields[field].changed === true)){
          console.log(field)
          continue
        }
        delete(updatePrivateProfile[field as keyof UserPrivateProfile])
      }
        
      if(Object.keys(updatePrivateProfile).length > 0){

        this.$store.commit("setLoading",true);
        this.isLoading = true

        await this.$updateDoc(this.$getUserPrivateProfileDocRef(),updatePrivateProfile)

          this.notice = {
            message: this.$t('profile.updated') as string,
            isShow: true,
            type: {'is-success': true}
          }
          this.observer.reset()
      }else{
        this.notice = {
          message: this.$t('profile.noChangedFields') as string,
          isShow: true,
          type: {'is-info': true}
        }
      }
      
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('profile.error') as string
      
			const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
      this.observer.reset()
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.disabledUpdateSettings = true
    }
  }

}
